import { Injectable, signal } from '@angular/core';

import { StorageService } from '../storage';

import { Environment } from './types';

const URLs: Record<Environment, string> = {
  [Environment.Debug]: 'smartchargeapipd.azurewebsites.net/v2',
  [Environment.Production]: 'api.current.eco/v2',
  [Environment.QA]: 'meshcrafts-demo-api-app-service-qa.azurewebsites.net/v2',
  [Environment.Sandbox]: 'current-api-sandbox.azurewebsites.net/v2',
  [Environment.Services]: 'services.current.eco',
  [Environment.Staging]: 'meshcrafts-demo-api-app-service-stagging.azurewebsites.net/v2'
};

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  readonly environment = signal<Environment>(Environment.Production);

  private production = true;

  constructor(private readonly storage: StorageService) {}

  get apiURL(): string {
    return `https://${this.baseURL}`;
  }

  get baseURL(): string {
    return `${URLs[this.environment()]}/`;
  }

  get isProduction(): boolean {
    return this.production;
  }

  get socketURL(): string {
    return `wss://${this.baseURL}`;
  }

  async init(fallback?: Environment): Promise<void> {
    let env = await this.storage.get<Environment>('environment');

    if (!Object.values(Environment).includes(env)) {
      env = fallback || Environment.Production;
    }

    await this.setEnvironment(env);
  }

  async setEnvironment(environment: Environment, production?: boolean): Promise<void> {
    this.environment.set(environment);
    this.production = production || environment === Environment.Production;

    await this.storage.set('environment', environment);
  }
}
